var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      width: "1000",
      maxWidth: "1000",
      title: _vm.$t("label_essweb_RosterFormRecord_form_dialog_editStaffTitle"),
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                height: 500,
                itemKey: "staff_id",
                defaultSelect: _vm.selected,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
              },
              on: {
                select: function (sel) {
                  return (_vm.selected = sel)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.staffid",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(
                          item.staff_code ? item.staff_code : item.staff_id
                        )
                      ),
                    ]
                  },
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "pa-0",
                          staticStyle: { "max-width": "200px" },
                          attrs: { dense: "" },
                        },
                        [
                          _c(
                            "v-list-item-avatar",
                            {
                              staticClass: "mr-1 my-0 pa-0",
                              attrs: { size: "36" },
                            },
                            [
                              _c("StaffAvatar", {
                                attrs: {
                                  size: "36",
                                  src: item.staff_avatar,
                                  staff_name: item.preferred_name,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "text--primary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        item.preferred_name
                                      )
                                    ) + " "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text--secondary text-caption-xs",
                                    },
                                    [_vm._v(" " + _vm._s(item.staff_code))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.job",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary text-left" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.job_post_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.toSave, cancel: _vm.closePorpertyDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }